import { createSelector } from 'reselect';
// import { todayWithoutMinutes } from '../../utils';
import { EVENTS as EVENTS_OBJECTTYPE } from '../../constants/objectTypes';
import { fileComponentKey as cKey } from '../../helpers/reducers';

import { generateRecurringEvents } from '../../selectors/entities';
import { getCurrentCasePermissions } from '../cases/selector';
import { getEmployerFeatures, getEmployerPermissions } from '../userProfile/selector';
import { canEdit, canView } from '../../helpers/permissions';
import { RESIDENT_CALENDAR } from '../../constants/permissions';

import { formatEventObjForUI } from './event_UI_helpers';
import { getEventsArrayForCurrentCase } from '../../selectors/entities';

const followers = (state) => state.entities.followers;
const getEvents = (state) => state.entities.calendar;
const componentsUploads = (state) => state.screens.components.uploads;
const getEditingEventId = (state) => state.screens.calendar.editingEventId;
const getEditingEventCaseId = (state) => state.screens.calendar.editingEventCaseId;
const getCalendarViewEmployerSetting = (state) => state.screens.calendar.calendarViewEmployer;

export const getEventsAndTaskListsFromCurrentCase = createSelector(
  getEventsArrayForCurrentCase,
  (events) => {
    if (!events) return [];
    let recurringEvents = [];

    // let startTime = Date.now();
    // console.info('generateRecurringEvents START', startTime);

    events.forEach((e) => {
      let temp = generateRecurringEvents(e);
      if (temp) {
        recurringEvents = recurringEvents.concat(temp.slice(1));
      }
    });
    events = events.slice().concat(recurringEvents);
    return events;
  }
);

export const getEditingEvent = createSelector(
  getEditingEventId,
  getEvents,
  getEditingEventCaseId,
  (eventId, events, caseId) => {
    if (!eventId || !events || !caseId) return null;
    return (events[caseId] && events[caseId][eventId]) || null;
  }
);

const filesForEditingEvent = (state) => {
  let fileCKey = cKey({
    objectType: EVENTS_OBJECTTYPE,
    objectId: state.screens.calendar.editingEventId,
  });
  console.log('filesForEditingEvent', fileCKey);
  return (state.entities.files[fileCKey] && state.entities.files[fileCKey].files) || null;
};
const employerEventById = (state, props) => {
  if (props.eventId == null) return null;
  return state.entities.employerCalendar[props.eventId] || null;
};

export const uiFormattedEditingEvent = createSelector(
  getEditingEvent,
  filesForEditingEvent,
  followers,
  (editingEvent, editingFiles, followers) => {
    if (!editingEvent) return null;
    return formatEventObjForUI(editingEvent, editingFiles || [], followers);
  }
);

export const uiFormattedEmployerEvent = createSelector(employerEventById, (editingEvent) => {
  if (!editingEvent) return null;
  return formatEventObjForUI(editingEvent, []);
});

export const getEventNotes = createSelector(getEditingEvent, (editingEvent) => {
  if (!editingEvent) return null;
  return editingEvent.notes;
});

export const getFileUploadStatusForEditingEvent = createSelector(
  getEditingEvent,
  componentsUploads,
  (editingEvent, uploads) => {
    if (!editingEvent) return {};
    let fileCKey = cKey({
      objectType: EVENTS_OBJECTTYPE,
      objectId: editingEvent.eventId,
    });
    return uploads[fileCKey] || {};
  }
);

export const canViewCalendar = createSelector(
  getCurrentCasePermissions,
  getEmployerPermissions,
  (casePermissions, employerPermissions) => {
    const perms = casePermissions || employerPermissions;
    return canView(perms, RESIDENT_CALENDAR);
  }
);
export const canEditCalendar = createSelector(
  getCurrentCasePermissions,
  getEmployerPermissions,
  (casePermissions, employerPermissions) => {
    const perms = casePermissions || employerPermissions;
    return canEdit(perms, RESIDENT_CALENDAR);
  }
);

export const canSeeAllResidentsCalendar = createSelector(
  getEmployerPermissions,
  getEmployerFeatures,
  (permissions, employerFeatures) => {
    return employerFeatures.orgCalendar;
  }
);

export const shouldShowAllResidentsInCal = createSelector(
  getCalendarViewEmployerSetting,
  canSeeAllResidentsCalendar,
  (calendarScreenSetting, canSeeIt) => {
    return canSeeIt && calendarScreenSetting !== false;
  }
);
